import React from 'react';
export const Editmodal = ({ editNote, setEditNote, notes, setNotes }) => {
  const saveChanges = () => {
    setNotes(notes.map(note =>
      note.id === editNote.id ? editNote : note
    ));
  };
  return (
    <>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Edit Note
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form style={{ border: "2px solid #ced4da", padding: "20px", borderRadius: "10px" }}>
                <div className="mb-3">
                  <label htmlFor="EditNotetitle" className="form-label">
                    <h5>Title</h5>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="EditNotetitle"
                    value={editNote?.title || ""}
                    onChange={e =>
                      setEditNote({ ...editNote, title: e.target.value })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="desc" className="form-label">Description</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    id="desc"
                    value={editNote?.desc || ""}
                    onChange={e =>
                      setEditNote({ ...editNote, desc: e.target.value })
                    }
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={saveChanges}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
